// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.schema-editor {
    height: 100%;
    width: 100%;
}
.editor:focus {
    border: 1px solid #C2BFBE !important;
    outline: none !important;

}
.schema-validator-container {
    display: inline;
    /* width: 100%; */
    /* height: 100%; */
}

.schema-editor-container {
    width: 70%;
    float: left;
    height: 100%;
    justify-content: center;
    display: flex;
    margin-top: -20px;
    /* border-right: 1px solid #C2BFBE; */
}
.validation-container {
    width: 28%;
    float: right;
    height: 100%;
}
html {
    height: 100%;
}
#root {
    height: 100%;
}

.schema-validation {
    height: auto;
    width: 90%;
    /* border: 1px solid #C2BFBE; */
    margin-top: 10%;
    margin-bottom: 10%;
}
.editor {
    /* height: 60%; */
    width: 100%;
    justify-content: center;
    display: inline-block;
    border: 1px solid #C2BFBE !important;
    margin-bottom: 20px;
}
.download-btn {
    justify-content: flex-end;
    margin-bottom: 1%;
    display: flex;
}

.footer-buttons {
    /* justify-content: space-between; */
    display: flex;
    justify-content: space-between;
    width: 100%;
}
.validate-btn {
    float: left;
    width: 33.33%;
}

.loader {
    border: 5px solid #f3f3f3; /* Light grey */
    border-top: 5px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 30px;
    height: 30px;
    animation: spin 2s linear infinite;
    margin: auto;
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
  
.line-breaks {
    border-color: solid #dee2e6;
}
body {
    font-family: Inter !important;
}

.accordion-success {
    background-color: #d9ffcc !important;
}
.accordion-error {
    background-color: #ffe6e6 !important;
}
.file-name {
    word-wrap: break-word;
}
`, "",{"version":3,"sources":["webpack://./src/components/styles/editorStyles.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,WAAW;AACf;AACA;IACI,oCAAoC;IACpC,wBAAwB;;AAE5B;AACA;IACI,eAAe;IACf,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,iBAAiB;IACjB,qCAAqC;AACzC;AACA;IACI,UAAU;IACV,YAAY;IACZ,YAAY;AAChB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,UAAU;IACV,+BAA+B;IAC/B,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,iBAAiB;IACjB,WAAW;IACX,uBAAuB;IACvB,qBAAqB;IACrB,oCAAoC;IACpC,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,oCAAoC;IACpC,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;AACA;IACI,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,yBAAyB,EAAE,eAAe;IAC1C,6BAA6B,EAAE,SAAS;IACxC,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,kCAAkC;IAClC,YAAY;EACd;;EAEA;IACE,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;EACpC;;AAEF;IACI,2BAA2B;AAC/B;AACA;IACI,6BAA6B;AACjC;;AAEA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qBAAqB;AACzB","sourcesContent":[".schema-editor {\n    height: 100%;\n    width: 100%;\n}\n.editor:focus {\n    border: 1px solid #C2BFBE !important;\n    outline: none !important;\n\n}\n.schema-validator-container {\n    display: inline;\n    /* width: 100%; */\n    /* height: 100%; */\n}\n\n.schema-editor-container {\n    width: 70%;\n    float: left;\n    height: 100%;\n    justify-content: center;\n    display: flex;\n    margin-top: -20px;\n    /* border-right: 1px solid #C2BFBE; */\n}\n.validation-container {\n    width: 28%;\n    float: right;\n    height: 100%;\n}\nhtml {\n    height: 100%;\n}\n#root {\n    height: 100%;\n}\n\n.schema-validation {\n    height: auto;\n    width: 90%;\n    /* border: 1px solid #C2BFBE; */\n    margin-top: 10%;\n    margin-bottom: 10%;\n}\n.editor {\n    /* height: 60%; */\n    width: 100%;\n    justify-content: center;\n    display: inline-block;\n    border: 1px solid #C2BFBE !important;\n    margin-bottom: 20px;\n}\n.download-btn {\n    justify-content: flex-end;\n    margin-bottom: 1%;\n    display: flex;\n}\n\n.footer-buttons {\n    /* justify-content: space-between; */\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n}\n.validate-btn {\n    float: left;\n    width: 33.33%;\n}\n\n.loader {\n    border: 5px solid #f3f3f3; /* Light grey */\n    border-top: 5px solid #3498db; /* Blue */\n    border-radius: 50%;\n    width: 30px;\n    height: 30px;\n    animation: spin 2s linear infinite;\n    margin: auto;\n  }\n  \n  @keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n  }\n  \n.line-breaks {\n    border-color: solid #dee2e6;\n}\nbody {\n    font-family: Inter !important;\n}\n\n.accordion-success {\n    background-color: #d9ffcc !important;\n}\n.accordion-error {\n    background-color: #ffe6e6 !important;\n}\n.file-name {\n    word-wrap: break-word;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
